import { apiSlice, asyncToastDisplay, i18n } from "./apiSlice";

export const pageElementApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPageElements: builder.query({
      query: () => {
        return `/page_elements`
      },
      providesTags: (result = [], error, arg) => [{ type: 'PageElement', id: 'LIST' }],
    }),
    getPageElement: builder.query({
      query: (id) => {
        return `/page_elements/${id}`
      },
      providesTags: (result = [], error, arg) => [{ type: 'PageElement', id: arg }],
    }),
    updatePageContent: builder.mutation({
      query: (page_content) => ({
        url: `page_elements/${page_content.page_element_id}/page_contents/${page_content.language_code}`,
        method: 'PUT',
        body: page_content,
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.updated")}),
      invalidatesTags: (result, error, arg) => [{ type: 'PageElement', id: arg.page_element_id }],
    })
  }),
  overrideExisting: false
})

export const {
  useGetPageElementsQuery,
  useGetPageElementQuery,
  useUpdatePageContentMutation
} = pageElementApiSlice
